/* eslint-disable */
export default {
  _IntroSwipeAnimation_9: 'IntroSwipeAnimation/9',
  _IntroSwipeAnimation_2: 'IntroSwipeAnimation/2',
  _MouseTrail: 'MouseTrail',
  _HandPointer: 'HandPointer',
  _plus40: 'plus40',
  _TitleHeader_1: 'TitleHeader_1',
  _plus20: 'plus20',
  _plus30: 'plus30',
  _XIndicator: 'XIndicator',
  _IntroSwipeAnimation_8: 'IntroSwipeAnimation/8',
  _plus10: 'plus10',
  _IntroSwipeAnimation_3: 'IntroSwipeAnimation/3',
  _XIndicator_small: 'XIndicator_small',
  _IntroSwipeAnimation_7: 'IntroSwipeAnimation/7',
  _IntroSwipeAnimation_5: 'IntroSwipeAnimation/5',
  _IntroSwipeAnimation_4: 'IntroSwipeAnimation/4',
  _MouseTrail1: 'MouseTrail1',
  _IntroSwipeAnimation_0: 'IntroSwipeAnimation/0',
  _GameOverHeader: 'GameOverHeader',
  _TitleHeader_2: 'TitleHeader_2',
  _IntroSwipeAnimation_6: 'IntroSwipeAnimation/6',
  _ComboText: 'ComboText',
  _IntroSwipeAnimation_1: 'IntroSwipeAnimation/1',
  _TimesUpDisplay: 'TimesUpDisplay',
}